
import Vue from "vue";
import TimePickerField from "@/components/form/fields/time_picker/TimePickerField.vue";
import DatePickerField from "@/components/form/fields/date_picker/DatePickerField.vue";
import DropdownField from "@/components/form/fields/dropdown/DropdownField.vue";
import CheckboxGroupField from "@/components/form/fields/checkbox_group/CheckboxGroupField.vue";
import RadioGroupField from "@/components/form/fields/radio_group/RadioGroupField.vue";
import LongAnswerField from "@/components/form/fields/LongAnswerField.vue";
import ShortAnswerField from "@/components/form/fields/ShortAnswerField.vue";
import LinearScaleField from "@/components/form/fields/linear_scale/LinearScaleField.vue";
import DividerField from "@/components/form/fields/divider/DividerField.vue";

export default Vue.extend({
  name: "FormPreview",
  components: {
    LinearScaleField,
    ShortAnswerField,
    LongAnswerField,
    RadioGroupField,
    CheckboxGroupField,
    DropdownField,
    DatePickerField,
    TimePickerField,
    DividerField
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      default: () => {
        return {};
      },
    },
    form: {
      type: Object,
      default: () => {
        return {
          title: "",
          description: "",
          photoUrl: "",
          questions: [
            {
              title: "",
              type: "text-field",
              required: false,
              options: [""],
              linearScale: {
                minValue: 0,
                maxValue: 0,
                minLabel: "",
                maxLabel: "",
              },
            },
          ],
        }
      }
    }
  },
  data() {
    return {
      replyForm: this.value
    }
  },
  methods: {
    getImageUrl(imageUrl: string) {
      if (imageUrl.split(':')[0] === 'blob') {
        return imageUrl;
      }
      const api_url = process.env.VUE_APP_API_URL;
      return `${api_url}/files/${imageUrl}`;
    },
    cleanForm() {
      this.$emit("cleanForm");
    },
    validateForm() {
      const form: any = this.$refs.form;
      if (form) {
        form.validate();
      }
    },
    getTotalScore() {
      if(this.replyForm && this.form.questions) {
        let totalScore = 0;
        for(let i = 0; i < this.form.questions.length; i++) {
          let iAnswer = this.replyForm.answers[i];
          let question = this.form.questions[i];
          if(['radio-group', 'checkbox', 'select'].includes(question.type) && iAnswer.value[0] != null) {
            if(question.type === 'checkbox') {
              for(let j = 0; j < iAnswer.value.length; j++) {
                let selectedAnswer = iAnswer.value[j];
                let index = this.form.questions[i].options.indexOf(selectedAnswer);
                if(index >= 0) {
                  totalScore += parseInt(this.form.questions[i].scoreList[index])
                }
              }
            } else {
              let index = this.form.questions[i].options.indexOf(iAnswer.value[0]);
              if(index >= 0) {
                totalScore += parseInt(this.form.questions[i].scoreList[index])
              }
            }

          }
        }
        return totalScore;
      }

      return 0;
    },
    questionGetProps(type: string, question: any) {
      switch (type) {
        case 'text-field':
          return {
            label: this.$t('forms.form.preview.yourAnswer'),
            required: question.required,
            validation: question.validation,
            extraValidations: question.extraValidations,
          };
        case 'text-area':
          return {
            label: this.$t('forms.form.preview.yourAnswer'),
            required: question.required,
            validation: question.validation,
            extraValidations: question.extraValidations,
          };
        case 'radio-group':
          return {
            options: question.options,
            required: question.required,
            validation: question.validation,
            extraValidations: question.extraValidations,
            score: this.form.score,
            scores: question.scoreList,
          };
        case 'checkbox':
          return {
            options: question.options,
            required: question.required,
            validation: question.validation,
            extraValidations: question.extraValidations,
            score: this.form.score,
            scores: question.scoreList,
          };
        case 'date-input':
          return {
            label: this.$t('forms.form.preview.pickDate'),
            required: question.required,
            validation: question.validation,
            extraValidations: question.extraValidations,
          };
        case 'select':
          return {
            label: this.$t('forms.form.preview.chooseOption'),
            required: question.required,
            options: question.options,
            validation: question.validation,
            extraValidations: question.extraValidations,
            score: this.form.score,
            scores: question.scoreList,
          };
        case 'linear-scale':
          return {
            required: question.required,
            min: parseInt(question.linearScale.minValue),
            max: parseInt(question.linearScale.maxValue),
            fromLabel: question.linearScale.minLabel,
            toLabel: question.linearScale.maxLabel,
            validation: question.validation,
            extraValidations: question.extraValidations,
          };
        case 'divider':
          return {};
        default:
          return {
            required: question.required,
            label: this.$t('forms.form.preview.yourAnswer'),
            validation: question.validation,
            extraValidations: question.extraValidations,
          };
      }
    }
  },
  watch: {
    replyForm: function (form) {
      this.replyForm = form;
      this.$emit("input", form);
    },
  },
  computed: {
    questionTypeComponent: {
      set() {
        return [];
      },
      get() {
        return {
          'text-field': 'short-answer-field',
          'text-area': 'long-answer-field',
          'radio-group': 'radio-group-field',
          'checkbox': 'checkbox-group-field',
          'date-input': 'date-picker-field',
          'time-input': 'time-picker-field',
          'select': 'dropdown-field',
          'linear-scale': 'linear-scale-field',
          'divider': 'divider-field',
        }
      }
    },
  }
});
